import Page from '../page';

const selectors = {
  addAllButton: '.js-addAll',
  rowCheckbox: '.js-rowSelect',
  formInputs: '.js-formInput',
};

export default class WebReturnsOrderDetails extends Page {
  private addAllButton: JQuery;

  constructor(private readonly body: JQuery) {
    super();
    this.addAllButton = this.body.find(selectors.addAllButton);
    this.bindRowSelectCheckboxChange();
  }

  private bindRowSelectCheckboxChange(): void {
    this.body.on('change', selectors.rowCheckbox, (e) => {
      const checkbox = $(e.target);
      checkbox.siblings(selectors.formInputs).prop('disabled', !checkbox.is(':checked'));
      this.addAllButton.prop('disabled', this.getNumSelectedCheckboxes() === 0);
    });
  }

  private getNumSelectedCheckboxes(): number {
    return this.body.find(selectors.rowCheckbox).filter(':checked').length;
  }
}
